import React, { useEffect, useState, useRef } from 'react';
import {
  Table,
  Button,
  Dialog,
  Input,
  Message,
  Card,
  Pagination,
  Form,
  NumberPicker,
} from '@alifd/next';
import 'antd/dist/antd.css';
import { useSelector } from 'react-redux';
import { Radio, Select, Image, Space, Typography, message, Tabs } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';
import axios from 'axios';
import Swal from 'sweetalert2';
import client from '../../../../lib/feathers';
import ezconImg from '../../../../../public/ezcon.png';
import styles from './index.module.scss';
import Setting from './Setting';

const { TabPane } = Tabs;
const { Option } = Select;
const PublicInformation = ({ showButton }) => {
  const user = useSelector((state) => state.user);
  const [allowedFuncs, setAllowedFuncs] = useState([]);
  const publicInformationHour = client.service('publicInformationHour');
  const publicInformationCount = client.service('publicInformationCount');
  const baDevice = client.service('baDevice');

  const [publicInformationHourArr, setPublicInformationHourArr] = useState([]);
  const [publicInformationCountArr, setPublicInformationCountArr] = useState(
    []
  );
  const [publicName, setPublicName] = useState('');
  const [publicUsageTime, setPublicUsageTime] = useState(1);
  const [publicExpireTime, setPublicExpireTime] = useState(1);
  const [publicExpireUnit, setPublicExpireUnit] = useState('日');
  const [publicMultipleAppointments, setPublicMultipleAppointments] =
    useState('');
  const [publicMaxAppointmentsNumber, setPublicMaxAppointmentsNumber] =
    useState('');
  const [publicDeductPoints, setPublicDeductPoints] = useState('');
  const [publicRentalEquipment, setPublicRentalEquipment] = useState([]);
  const [publicContent, setPublicContent] = useState('');
  // Remarks
  const [publicOpenTimeRemarks, setPublicOpenTimeRemarks] = useState('');
  // Edit
  const [editPublicIndex, setEditPublicIndex] = useState('');
  const [addPublicHourDialog, setAddPublicHourDialog] = useState(false);
  const [addPublicCountDialog, setAddPublicCountDialog] = useState(false);
  const [editPublicHourDialog, setEditPublicHourDialog] = useState(false);
  const [editPublicCountDialog, setEditPublicCountDialog] = useState(false);
  const [previewHourDialog, setPreviewHourDialog] = useState(false);
  const [previewCountDialog, setPreviewCountDialog] = useState(false);
  const [previewHour, setPreviewHour] = useState([]);
  const [previewCount, setPreviewCount] = useState([]);

  const [uploadPath, setUploadPath] = useState('');
  const [uploadData, setUploadData] = useState(null);
  const [attachment, setAttachment] = useState(null);
  const [errorText, setErrorText] = useState('');

  // BADevice
  const [baDeviceArr, setBaDeviceArr] = useState([]);
  const [publicBaId, setPublicBaId] = useState([]);

  const uploadRef = useRef(null);
  // sort
  const [curdataIndex, setcurDataIndex] = useState('createdTime');
  const [curorder, setcurOrder] = useState('desc');
  useEffect(() => {
    if (user.userGroup.key) {
      const checkedKeys = user.userGroup.key.checkedKeys;
      setAllowedFuncs(checkedKeys);
    }
  }, [user]);

  async function findHour(para) {
    const result = await publicInformationHour.find({ query: para });
    return result && result.data ? result.data : [];
  }
  async function removeHour(id) {
    return await publicInformationHour.remove(id);
  }

  function updatedTimeSort(a, b) {
    return a.updatedTime < b.updatedTime ? 1 : -1;
  }
  async function serverDataUpdate() {
    findHour({}).then((result) => {
      console.log('resultaaaaa', result);
      setPublicInformationHourArr(result.sort(updatedTimeSort));
    });
  }
  useEffect(() => {
    serverDataUpdate();
    funHourSortUpdate();
    baDevice
      .find({ query: { group: '門禁', broadcastType: '公設點數' } })
      .then((res) => {
        console.log(res);
        setBaDeviceArr(res.data);
      });
  }, []);

  // publicInformationCount
  async function findCount(para) {
    const result = await publicInformationCount.find({ query: para });
    return result && result.data ? result.data : [];
  }
  async function removeCount(id) {
    return await publicInformationCount.remove(id);
  }

  function updatedTimeSortNew(a, b) {
    return a.updatedTime < b.updatedTime ? 1 : -1;
  }
  function serverDataUpdateNew() {
    findCount({}).then((result) => {
      setPublicInformationCountArr(result.sort(updatedTimeSortNew));
    });
  }
  useEffect(() => {
    serverDataUpdateNew();
    funCountSortUpdate();
  }, []);

  // uploads files
  const [parsed, setParsed] = useState([]);
  const [parsed64, setParsed64] = useState([]); // Base64
  const [file, setFile] = useState('');
  const uploadFile = useRef(null);

  function beforeUpload() {
    return new Promise((resolve, reject) => {
      (async () => {
        if (uploadFile.current.files.length > 0) {
          const isLt20M =
            (await uploadFile.current.files[0].size) / 1024 / 1024 < 20;

          if (!isLt20M) {
            Message.error('Image must smaller than 20MB!');
            return reject();
          }
          resolve(isLt20M);
        } else {
          setParsed64('');
        }
      })();
    });
  }

  const handleFiles = async () => {
    try {
      await beforeUpload();
      const files = [...parsed];
      const data = await uploadFile.current.files[0];

      files.push(data);
      setParsed(files);

      // 轉Base64 上傳檔案後呈現沒有寫到DB
      const reader = new FileReader();
      reader.onload = function () {
        const dataURL = reader.result;
        setParsed64(dataURL);
      };
      reader.readAsDataURL(data);
    } catch (err) {
      console.log(err);
    }
  };

  const funHourSortUpdate = (dataIndex, order) => {
    const rdataIndex = dataIndex || curdataIndex;
    const rorder = order || curorder;

    publicInformationHour.find({}).then((res) => {
      setPublicInformationHourArr(
        res.data.sort((a, b) => {
          const result = (
            typeof a[rdataIndex] === 'number'
              ? a[rdataIndex].toString()
              : a[rdataIndex]
          ).localeCompare(
            typeof b[rdataIndex] === 'number'
              ? b[rdataIndex].toString()
              : b[rdataIndex]
          );
          return (rorder === 'asc') === result > 0 ? 1 : -1;
        })
      );
    });
  };
  const funCountSortUpdate = (dataIndex, order) => {
    const rdataIndex = dataIndex || curdataIndex;
    const rorder = order || curorder;

    publicInformationCount.find({}).then((res) => {
      setPublicInformationCountArr(
        res.data.sort((a, b) => {
          const result = (
            typeof a[rdataIndex] === 'number'
              ? a[rdataIndex].toString()
              : a[rdataIndex]
          ).localeCompare(
            typeof b[rdataIndex] === 'number'
              ? b[rdataIndex].toString()
              : b[rdataIndex]
          );
          return (rorder === 'asc') === result > 0 ? 1 : -1;
        })
      );
    });
  };
  const onTableHourSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    funHourSortUpdate(dataIndex, order);
  };
  const onTableCountSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    funCountSortUpdate(dataIndex, order);
  };

  // 換頁
  const [currentPageHour, setCurrentPageHour] = useState(1);
  const [currentPageCount, setCurrentPageCount] = useState(1);
  const [postsPerPage] = useState(10);

  const indexOfLastPostHour = currentPageHour * postsPerPage;
  const indexOfFirstPostHour = indexOfLastPostHour - postsPerPage;

  const indexOfLastPostCount = currentPageCount * postsPerPage;
  const indexOfFirstPostCount = indexOfLastPostCount - postsPerPage;

  const currentCountPosts = publicInformationCountArr.slice(
    indexOfFirstPostCount,
    indexOfLastPostCount
  );
  const currentHourPosts = publicInformationHourArr.slice(
    indexOfFirstPostHour,
    indexOfLastPostHour
  );

  // 處理營業時間
  const week = ['一', '二', '三', '四', '五', '六', '日'];
  const [dayAllowTime, setDayAllowTime] = useState([
    [],
    [],
    [],
    [],
    [],
    [],
    [],
  ]);
  const [openTime, setOpenTime] = useState([[], [], [], [], [], [], []]);
  const [openTimeDialog, setOpenTimeDialog] = useState(false);
  const [openTimeIndex, setOpenTimeIndex] = useState(0);
  const [openTimeStatus, setOpenTimeStatus] = useState([
    'no',
    'no',
    'no',
    'no',
    'no',
    'no',
    'no',
  ]);

  const select = (
    <Select
      aria-label="please select"
      style={{ width: 70 }}
      value={publicExpireUnit}
      onChange={(value) => setPublicExpireUnit(value)}
    >
      <option value="d">日</option>
      <option value="M">月</option>
      <option value="y">年</option>
    </Select>
  );

  return (
    <>
      <Button
        type="secondary"
        style={{ marginBottom: '10px' }}
        onClick={() => {
          setAddPublicHourDialog(true);
          setErrorText('');
          setPublicUsageTime(1);
        }}
      >
        建立公設(時段預約)
      </Button>
      <Button
        type="secondary"
        style={{ marginLeft: '10px', marginBottom: '10px' }}
        onClick={() => {
          setAddPublicCountDialog(true);
          setErrorText('');
        }}
      >
        建立公設(計次預約)
      </Button>

      <Setting showButton={showButton} />
      <br />

      {/* 時段預約新增 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addPublicHourDialog}
        onOk={async () => {
          if (!publicName) {
            Message.warning('請填寫公設名稱');
            return;
          } else if (!publicUsageTime) {
            Message.warning('請選擇使用時間限制');
            return;
          } else if (!publicMultipleAppointments) {
            Message.warning('請勾選是否同時段多戶預約');
            return;
          } else if (!publicMaxAppointmentsNumber) {
            Message.warning('請填寫容納人數');
            return;
          }
          if (publicName) {
            const hourRes = await publicInformationHour.find({
              query: { publicName },
            });
            const countRes = await publicInformationCount.find({
              query: { publicName },
            });
            if (hourRes.total > 0 || countRes.total > 0) {
              Message.warning('此公設名稱已存在');
              return;
            }
          }

          const result = await Swal.fire({
            title: `確定新增(${publicName})公設?`,
            text: '請確認資料填寫完整!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          });
          if (result.isConfirmed) {
            Swal.fire('成功!', '此公設已新增', 'success');
            //  是否有上傳規範

            let nowRule = {};
            if (uploadData) {
              const body = new FormData();
              body.append('files', uploadData);
              if (uploadData.size / 1024 / 1024 > 20) {
                return Message.error('上傳檔案不能超過20MB');
              }

              const res = await axios(
                '/newUploads?type=publicInformationHour&category=規範',
                {
                  method: 'POST',
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                  data: body,
                }
              );
              const { showPath, _id } = await res.data;
              nowRule = {
                path: showPath,
                name: uploadData.name,
                id: _id,
              };
            }

            const formData = new FormData();
            formData.append('createdTime', new Date().getTime());
            formData.append('updatedTime', new Date().getTime());
            formData.append('publicName', publicName);
            formData.append('publicUsageTime', parseInt(publicUsageTime, 10));
            formData.append(
              'publicExpireTime',
              publicExpireTime + publicExpireUnit
            );
            formData.append('publicDeductPoints', publicDeductPoints);
            formData.append(
              'publicMultipleAppointments',
              publicMultipleAppointments
            );
            formData.append(
              'publicMaxAppointmentsNumber',
              publicMaxAppointmentsNumber
            );
            formData.append(
              'publicRentalEquipment',
              JSON.stringify(publicRentalEquipment)
            );

            formData.append('publicContent', publicContent);
            formData.append('publicOpenTimeRemarks', publicOpenTimeRemarks); // 備註
            formData.append('dayAllowTime', JSON.stringify(dayAllowTime)); // 開放時間
            formData.append('openTimeStatus', JSON.stringify(openTimeStatus)); // 開放時段
            formData.append('baId', JSON.stringify(publicBaId)); // baId
            if (uploadData) {
              formData.append('rule', JSON.stringify(nowRule));
            }
            if (uploadFile.current.files.length > 0) {
              formData.append('files', uploadFile.current.files[0]);
            }

            await axios('/uploads?type=publicInformationHour', {
              method: 'POST',
              headers: { authorization: window.localStorage['feathers-jwt'] },
              data: formData,
            });

            serverDataUpdate();
            funHourSortUpdate();
            setPublicName('');
            setPublicUsageTime('');
            setPublicMultipleAppointments('');
            setPublicMaxAppointmentsNumber('');
            setPublicDeductPoints('');
            setPublicRentalEquipment('');
            setPublicContent('');
            setFile('');
            setParsed64('');
            setUploadData('');
            setOpenTime([[], [], [], [], [], [], []]);
            setOpenTimeStatus(['no', 'no', 'no', 'no', 'no', 'no', 'no']);
            setOpenTimeIndex(1);
            setDayAllowTime([[], [], [], [], [], [], []]);
            setAddPublicHourDialog(false);
            setPublicExpireTime(1);
            setPublicExpireUnit('天');
            setPublicBaId([]);
          }
        }}
        onCancel={() => {
          setPublicName('');
          setPublicUsageTime('');
          setPublicMultipleAppointments('');
          setPublicMaxAppointmentsNumber('');
          setPublicDeductPoints('');
          setPublicRentalEquipment('');
          setPublicContent('');
          setPublicOpenTimeRemarks('');
          setFile('');
          setParsed64('');
          setOpenTime([[], [], [], [], [], [], []]);
          setOpenTimeStatus(['no', 'no', 'no', 'no', 'no', 'no', 'no']);
          setOpenTimeIndex(1);
          setDayAllowTime([[], [], [], [], [], [], []]);
          setPublicExpireTime(1);
          setPublicExpireUnit('天');
          setAddPublicHourDialog(false);
          setPublicBaId([]);
        }}
        onClose={() => {
          setPublicName('');
          setPublicUsageTime('');
          setPublicMultipleAppointments('');
          setPublicMaxAppointmentsNumber('');
          setPublicDeductPoints('');
          setPublicRentalEquipment('');
          setPublicContent('');
          setPublicOpenTimeRemarks('');
          setFile('');
          setParsed64('');
          setOpenTime([[], [], [], [], [], [], []]);
          setOpenTimeStatus(['no', 'no', 'no', 'no', 'no', 'no', 'no']);
          setOpenTimeIndex(1);
          setDayAllowTime([[], [], [], [], [], [], []]);
          setPublicExpireTime(1);
          setPublicExpireUnit('天');
          setAddPublicHourDialog(false);
          setPublicBaId([]);
        }}
      >
        <h1>公設資料</h1>
        <div className={styles.publicInformationContainer}>
          <div className={styles.publicContainerLeft}>
            <Form.Item label="公設名稱">
              <Input
                name="publicName"
                placeholder="請輸入公設名稱"
                onChange={async (value) => {
                  setPublicName(value);
                  const hourRes = await publicInformationHour.find({
                    query: { publicName: value },
                  });
                  const countRes = await publicInformationCount.find({
                    query: { publicName: value },
                  });
                  if (hourRes.total > 0 || countRes.total > 0) {
                    setErrorText('此公設名稱已存在');
                  } else {
                    setErrorText('');
                  }
                }}
              />
              {errorText && <p style={{ color: '#FF0000' }}>{errorText}</p>}
            </Form.Item>

            <Form.Item label="使用時間限制">
              <NumberPicker
                value={publicUsageTime}
                min={1}
                onChange={(value) => {
                  setPublicUsageTime(value);
                }}
              />
              小時
            </Form.Item>
            <Form.Item label="開放預約期限">
              <Input.Group addonAfter={select}>
                <NumberPicker
                  value={publicExpireTime}
                  min={1}
                  onChange={(value) => {
                    setPublicExpireTime(value);
                  }}
                />
              </Input.Group>
            </Form.Item>
            <Form.Item label="是否同時段多戶預約">
              <Radio.Group
                onChange={(e) => {
                  setPublicMultipleAppointments(e.target.value);
                }}
                // value={publicMultipleAppointments}
              >
                <Radio value="是">是</Radio>
                <Radio value="否">否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item label="容納人數">
              <Input
                name="publicMaxAppointmentsNumber"
                placeholder="請輸入人數"
                onChange={(value) => {
                  setPublicMaxAppointmentsNumber(value);
                }}
              />
            </Form.Item>
            {allowedFuncs.includes('點數管理') && (
              <Form.Item label="扣點方式">
                <Input
                  name="publicDeductPoints"
                  placeholder="請輸入點數"
                  onChange={(value) => {
                    setPublicDeductPoints(value);
                  }}
                />
              </Form.Item>
            )}
            <Form.Item label="可出租設備">
              <Select
                mode="tags"
                style={{ width: '100%' }}
                placeholder="請輸入設備名稱 按Enter確"
                onChange={(value) => {
                  setPublicRentalEquipment(value);
                }}
              />
            </Form.Item>
            <Form.Item label="公設簡介">
              <Input.TextArea
                name="publicContent"
                placeholder="請輸入內容"
                maxLength={100}
                rows={4}
                hasLimitHint
                aria-label="input max length 100"
                onChange={(value) => {
                  setPublicContent(value);
                }}
              />
            </Form.Item>
          </div>

          <div className={styles.publicContainerRight}>
            <Form.Item label="上傳照片">
              <Button
                onClick={() => {
                  uploadFile.current.click();
                }}
              >
                選擇檔案
              </Button>
              <input
                accept="image/png, image/jpeg"
                ref={uploadFile}
                onChange={handleFiles}
                style={{ display: 'none' }}
                type="file"
                id="file"
                name="files"
                // multiple
              />
            </Form.Item>
            <Image
              className={styles.photo}
              src={`${parsed64.length > 0 ? parsed64 : ezconImg}`}
              alt="圖片"
            />
            <Form.Item label="上傳設施規範">
              {' '}
              <Space wrap>
                <Button
                  onClick={() => {
                    uploadRef.current.click();
                  }}
                >
                  {attachment ? '更換附件' : '上傳附件'}
                </Button>
                {uploadData && (
                  <>
                    <Typography.Text type="secondary">
                      {uploadData.name}
                    </Typography.Text>
                    <Button
                      text
                      onClick={() => {
                        setUploadData(null);
                        setUploadPath('');
                      }}
                      style={{ opacity: 0.45 }}
                    >
                      清除
                    </Button>
                  </>
                )}
              </Space>
              <input
                ref={uploadRef}
                type="file"
                id="upload"
                value={uploadPath || ''}
                style={{ display: 'none' }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  setUploadData(file);
                  setUploadPath(e.target.value);
                }}
              />
            </Form.Item>
            <Form.Item label="BA語音播放">
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                onChange={(value) => setPublicBaId(value)}
              >
                {baDeviceArr.map((item) => (
                  <Option value={item._id}>{item.tableText}</Option>
                ))}
              </Select>
            </Form.Item>
            {/* <img style={{ width: "50px", height: "50px" }} src={`${parsed64.length > 0 ? parsed64 : ezconImg}`} alt="圖片"></img> */}
            <Form.Item label="開放時間">
              <div className={styles.openTime}>
                {dayAllowTime.map((dayItem, index) => (
                  <div className={styles.OpenTimeContent}>
                    <div>
                      星期{week[index]}{' '}
                      <EditOutlined
                        style={{ marginLeft: '10px' }}
                        onClick={() => {
                          setOpenTimeIndex(index);
                          setOpenTimeDialog(true);
                          setOpenTime(dayAllowTime);
                        }}
                      />
                    </div>
                    <div>
                      {dayItem.length === 0 ? (
                        <div>非開放</div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'right',
                          }}
                        >
                          {dayItem.map((timeItem) => {
                            if (timeItem[0] === 0 && timeItem[1] === 24) {
                              return <div>24小時開放</div>;
                            } else {
                              return (
                                <div>{`${timeItem[0]}:00 - ${timeItem[1]}:00`}</div>
                              );
                            }
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <p>備註</p>
              <Input.TextArea
                name="publicOpenTimeContent"
                placeholder="請輸入內容"
                maxLength={100}
                rows={4}
                hasLimitHint
                aria-label="input max length 100"
                onChange={(value) => {
                  setPublicOpenTimeRemarks(value);
                }}
              />
            </Form.Item>
          </div>
        </div>
      </Dialog>

      {/* 選擇開放時間星期 */}
      <Dialog
        width={600}
        overflowScroll
        hasMask
        className={styles.openTimeDialog}
        visible={openTimeDialog}
        onCancel={() => {
          setOpenTimeDialog(false);
        }}
        onClose={() => {
          setOpenTimeDialog(false);
        }}
        onOk={() => {
          setOpenTimeDialog(false);
          const newOpenTime = JSON.parse(JSON.stringify(openTime));
          setDayAllowTime(newOpenTime);
        }}
      >
        <h3>設定開放時間</h3>
        <Tabs defaultActiveKey={openTimeIndex.toString()}>
          {openTime.map((item, index) => (
            <TabPane tab={`星期${week[index]}`} key={index.toString()}>
              <Radio.Group
                value={openTimeStatus[index]}
                onChange={(e) => {
                  const temp = [...openTimeStatus];

                  temp[index] = e.target.value;
                  setOpenTimeStatus(temp);
                  const newOpenTime = [...openTime];
                  if (e.target.value === 'all') {
                    newOpenTime[index] = [[0, 24]];
                  } else if (e.target.value === 'no') {
                    newOpenTime[index] = [];
                    setOpenTime(newOpenTime);
                  } else if (e.target.value === 'yes') {
                    newOpenTime[index] = [[0, 23]];
                  }
                  setOpenTime(newOpenTime);
                }}
              >
                <Radio value="yes">開放</Radio>
                <Radio value="all">開放24小時</Radio>
                <Radio value="no">非開放</Radio>
              </Radio.Group>

              {openTimeStatus[index] === 'yes' && (
                <>
                  <div style={{ marginTop: 10 }}>
                    <Button
                      onClick={() => {
                        const temp = [...openTime];
                        temp[index].push([0, 23]);
                        setOpenTime(temp);
                      }}
                    >
                      新增開放時間
                    </Button>
                  </div>
                  {openTime[index].length > 0 && (
                    <div className={styles.endTimeText}>
                      時間為24小時制，請輸入0-24的數字
                    </div>
                  )}

                  {openTime[index].map((openTimeItem, index2) => (
                    <div className={styles.openTimeItem}>
                      <div>
                        開始時間:
                        <NumberPicker
                          max={24}
                          min={0}
                          value={openTimeItem[0]}
                          innerAfter="：00"
                          onChange={(value) => {
                            const temp = [...openTime];
                            temp[index][index2][0] = value;
                            setOpenTime(temp);
                            if (value > openTimeItem[1]) {
                              message.error('開始時間不可大於結束時間');
                            }
                          }}
                        />
                      </div>
                      <div style={{ paddingLeft: 10 }}>
                        結束時間:
                        <NumberPicker
                          max={24}
                          min={0}
                          value={openTimeItem[1]}
                          innerAfter="：00"
                          onChange={(value) => {
                            const temp = [...openTime];
                            temp[index][index2][1] = value;
                            setOpenTime(temp);
                            if (value < openTimeItem[0]) {
                              message.error('結束時間不可小於開始時間');
                            }
                          }}
                        />
                      </div>
                      <div style={{ paddingLeft: 20 }}>
                        <DeleteOutlined
                          onClick={() => {
                            const temp = [...openTime];
                            temp[index].splice(index2, 1);
                            setOpenTime(temp);
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </>
              )}
            </TabPane>
          ))}
          {/* <TabPane tab="Tab 1" key="0">
            Content of Tab Pane 1
          </TabPane>
          <TabPane tab="Tab 2" key="2">
            Content of Tab Pane 2
          </TabPane>
          <TabPane tab="Tab 3" key="3">
            Content of Tab Pane 3
          </TabPane> */}
        </Tabs>
      </Dialog>

      {/* previewHour 查看 */}
      <Dialog
        hasMask
        className={styles.previewDialog}
        visible={previewHourDialog}
        footerActions={['cancel']}
        onCancel={() => {
          setPreviewHour([]);
          setPreviewHourDialog(false);
        }}
        onClose={() => {
          setPreviewHour([]);
          setPreviewHourDialog(false);
        }}
      >
        {previewHour.map((list, index) => {
          return (
            <div key={index}>
              <h1>{list.publicName}</h1>
              <Form.Item label="公設簡介">
                <p>{list.publicContent}</p>
              </Form.Item>
              <Form.Item label="建立時間">
                <p>{moment(list.createdTime).format('YYYY-MM-DD HH:mm:ss')}</p>
              </Form.Item>
              <Form.Item label="使用時間限制">
                <p>{list.publicUsageTime}</p>
              </Form.Item>
              <Form.Item label="是否多戶預約">
                <p>{list.publicMultipleAppointments}</p>
              </Form.Item>
              <Form.Item label="容納人數">
                <p>{list.publicMaxAppointmentsNumber}</p>
              </Form.Item>
              {allowedFuncs.includes('點數管理') && (
                <Form.Item label="扣點方式(小時)">
                  <p>{list.publicDeductPoints}</p>
                </Form.Item>
              )}
              <Form.Item label="可出租設備">
                {list.publicRentalEquipment
                  ? list.publicRentalEquipment.map((list, index) => {
                      return <p key={index}>{list}</p>;
                    })
                  : '無'}
              </Form.Item>
              <Form.Item label="開放時間">
                {list.dayAllowTime.map((dayItem, index) => (
                  <div className={styles.openTimeShow}>
                    <div>
                      <p>星期{week[index]}: </p>
                    </div>
                    <div>
                      {dayItem.length === 0 && <div>非開放</div>}
                      {dayItem.length > 0 &&
                      dayItem[0][0] === 0 &&
                      dayItem[0][1] === 24 ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'right',
                          }}
                        >
                          <div>24小時開放</div>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'right',
                          }}
                        >
                          {dayItem.map((timeItem) => (
                            <div>
                              {timeItem[0]}:00–{timeItem[1]}:00
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </Form.Item>

              <Form.Item label="備註">
                <p>{list.publicOpenTimeRemarks}</p>
              </Form.Item>
              <Form.Item label="圖片">
                {list.files.map((item, index) => {
                  return (
                    <div key={index}>
                      {/* <img className={styles.photo} alt="No Data" src={item} /> */}
                      <Image
                        className={styles.photo}
                        src={item !== '' ? item : '/ezcon/icon/ic_photo.svg'}
                        alt="圖片"
                      />
                    </div>
                  );
                })}
              </Form.Item>
              <Form.Item label="設施規範">
                {list?.rule?.name ? (
                  <a href={list.rule.path} target="_blank">
                    {list.rule.name}
                  </a>
                ) : (
                  '無檔案'
                )}
              </Form.Item>
            </div>
          );
        })}
      </Dialog>

      {/* previewCount 查看 */}
      <Dialog
        hasMask
        className={styles.previewDialog}
        visible={previewCountDialog}
        footerActions={['cancel']}
        onCancel={() => {
          setPreviewCount([]);
          setPreviewCountDialog(false);
        }}
        onClose={() => {
          setPreviewCount([]);
          setPreviewCountDialog(false);
        }}
      >
        {previewCount.map((list, index) => {
          return (
            <div key={index}>
              <h1>{list.publicName}</h1>
              <Form.Item label="公設簡介">
                <p>{list.publicContent}</p>
              </Form.Item>
              <Form.Item label="建立時間">
                <p>{moment(list.createdTime).format('YYYY-MM-DD HH:mm:ss')}</p>
              </Form.Item>

              <Form.Item label="是否多戶預約">
                <p>{list.publicMultipleAppointments}</p>
              </Form.Item>
              <Form.Item label="容納人數">
                <p>{list.publicMaxAppointmentsNumber}</p>
              </Form.Item>
              {allowedFuncs.includes('點數管理') && (
                <Form.Item label="扣點方式(小時)">
                  <p>{list.publicDeductPoints}</p>
                </Form.Item>
              )}
              <Form.Item label="可出租設備">
                {list.publicRentalEquipment
                  ? list.publicRentalEquipment.map((list, index) => {
                      return <p key={index}>{list}</p>;
                    })
                  : '無'}
              </Form.Item>
              <Form.Item label="開放時間">
                {list.dayAllowTime.map((dayItem, index) => (
                  <div className={styles.openTimeShow}>
                    <div>
                      <p>星期{week[index]}: </p>
                    </div>
                    <div>
                      {dayItem.length === 0 && <div>非開放</div>}
                      {dayItem.length > 0 &&
                      dayItem[0][0] === 0 &&
                      dayItem[0][1] === 24 ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'right',
                          }}
                        >
                          <div>24小時開放</div>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'right',
                          }}
                        >
                          {dayItem.map((timeItem) => (
                            <div>
                              {timeItem[0]}:00–{timeItem[1]}:00
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </Form.Item>

              <Form.Item label="備註">
                <p>{list.publicOpenTimeRemarks}</p>
              </Form.Item>
              <Form.Item label="圖片">
                {list.files.map((item, index) => {
                  return (
                    <div key={index}>
                      {/* <img className={styles.imageUrl} alt="No Data" src={item} /> */}
                      <Image
                        className={styles.photo}
                        src={item !== '' ? item : '/ezcon/icon/ic_photo.svg'}
                        alt="圖片"
                      />
                    </div>
                  );
                })}
              </Form.Item>
              <Form.Item label="設施規範">
                {list?.rule?.name ? (
                  <a href={list.rule.path} target="_blank">
                    {list.rule.name}
                  </a>
                ) : (
                  '無檔案'
                )}
              </Form.Item>
            </div>
          );
        })}
      </Dialog>

      {/* 小時預約編輯 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={editPublicHourDialog}
        onOk={async () => {
          const result = await Swal.fire({
            title: `確定修改公設(${publicName})資料?`,
            text: '請確認修改資料!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          });
          if (result.isConfirmed) {
            Swal.fire('成功!', '此公設修改成功', 'success');
            let nowRule = [];
            if (uploadData) {
              const body = new FormData();
              body.append('files', uploadData);
              if (uploadData.size / 1024 / 1024 > 20) {
                return Message.error('上傳檔案不能超過20MB');
              }

              const res = await axios(
                '/newUploads?type=publicInformationHour&category=規範',
                {
                  method: 'POST',
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                  data: body,
                }
              );
              const { showPath, _id } = await res.data;
              nowRule = {
                path: showPath,
                name: uploadData.name,
                id: _id,
              };
            }

            const data = currentHourPosts[editPublicIndex];
            let patchUrl = `/uploads?type=publicInformationHour&id=${data._id}`;

            const formData = new FormData();
            formData.append('updatedTime', new Date().getTime());
            formData.append('publicName', publicName);
            formData.append('publicUsageTime', publicUsageTime);
            formData.append(
              'publicExpireTime',
              publicExpireTime + publicExpireUnit
            );
            formData.append('publicDeductPoints', publicDeductPoints);
            formData.append(
              'publicMultipleAppointments',
              publicMultipleAppointments
            );
            formData.append(
              'publicMaxAppointmentsNumber',
              publicMaxAppointmentsNumber
            );
            formData.append(
              'publicRentalEquipment',
              JSON.stringify(publicRentalEquipment)
            );
            formData.append('publicContent', publicContent);
            formData.append('publicOpenTimeRemarks', publicOpenTimeRemarks); // 備註
            formData.append('dayAllowTime', JSON.stringify(dayAllowTime)); // 開放時間
            formData.append('openTimeStatus', JSON.stringify(openTimeStatus)); // 開放時段
            formData.append('baId', JSON.stringify(publicBaId));
            if (uploadData) {
              formData.append('rule', JSON.stringify(nowRule));
            }
            if (uploadFile.current.files.length > 0) {
              formData.append('files', uploadFile.current.files[0]);
            }
            if (!uploadFile.current.files.length) {
              patchUrl = `/uploads?type=publicInformationHour&id=${data._id}&img=keep`;
            }

            await axios(patchUrl, {
              method: 'PATCH',
              headers: { authorization: window.localStorage['feathers-jwt'] },
              data: formData,
            });
            serverDataUpdate();
            setPublicName('');
            setPublicUsageTime('');
            setPublicMultipleAppointments('');
            setPublicMaxAppointmentsNumber('');
            setPublicDeductPoints('');
            setPublicRentalEquipment('');
            setPublicContent('');
            setPublicOpenTimeRemarks('');
            setFile('');
            setParsed64('');
            setPublicExpireTime(1);
            setPublicExpireUnit('天');
            setEditPublicHourDialog(false);
            setUploadData('');

            setOpenTime([[], [], [], [], [], [], []]);
            setOpenTimeStatus(['no', 'no', 'no', 'no', 'no', 'no', 'no']);
            setOpenTimeIndex(1);
            setDayAllowTime([[], [], [], [], [], [], []]);
            setPublicExpireTime(1);
            setPublicExpireUnit('天');
            setPublicBaId([]);
          }
        }}
        onCancel={() => {
          setPublicName('');
          setPublicUsageTime('');
          setPublicMultipleAppointments('');
          setPublicMaxAppointmentsNumber('');
          setPublicDeductPoints('');
          setPublicRentalEquipment('');
          setPublicContent('');
          setPublicOpenTimeRemarks('');
          setFile('');
          setParsed64('');
          setOpenTime([[], [], [], [], [], [], []]);
          setOpenTimeStatus(['no', 'no', 'no', 'no', 'no', 'no', 'no']);
          setOpenTimeIndex(1);
          setDayAllowTime([[], [], [], [], [], [], []]);
          setPublicExpireTime(1);
          setPublicExpireUnit('天');
          setAddPublicHourDialog(false);
          setEditPublicHourDialog(false);
          setPublicBaId([]);
        }}
        onClose={() => {
          setPublicName('');
          setPublicUsageTime('');
          setPublicMultipleAppointments('');
          setPublicMaxAppointmentsNumber('');
          setPublicDeductPoints('');
          setPublicRentalEquipment('');
          setPublicContent('');
          setPublicOpenTimeRemarks('');
          setFile('');
          setParsed64('');
          setOpenTime([[], [], [], [], [], [], []]);
          setOpenTimeStatus(['no', 'no', 'no', 'no', 'no', 'no', 'no']);
          setOpenTimeIndex(1);
          setDayAllowTime([[], [], [], [], [], [], []]);
          setPublicExpireTime(1);
          setPublicExpireUnit('天');
          setAddPublicHourDialog(false);
          setEditPublicHourDialog(false);
          setPublicBaId([]);
        }}
      >
        <h3>公設資料編輯</h3>
        <div className={styles.publicInformationContainer}>
          <div className={styles.publicContainerLeft}>
            <Form.Item label="公設名稱">
              <Input
                value={publicName}
                name="publicName"
                placeholder="請輸入公設名稱"
                onChange={(value) => {
                  setPublicName(value);
                }}
              />
            </Form.Item>

            <Form.Item label="使用時間限制">
              <NumberPicker
                value={publicUsageTime}
                min={1}
                onChange={(value) => {
                  setPublicUsageTime(value);
                }}
              />
              小時
            </Form.Item>
            <Form.Item label="開放預約期限">
              <Input.Group addonAfter={select}>
                <NumberPicker
                  value={publicExpireTime}
                  min={1}
                  onChange={(value) => {
                    setPublicExpireTime(value);
                  }}
                />
              </Input.Group>
            </Form.Item>
            <Form.Item label="是否同時段多戶預約">
              <Radio.Group
                onChange={(e) => {
                  setPublicMultipleAppointments(e.target.value);
                }}
                value={publicMultipleAppointments}
              >
                <Radio value="是">是</Radio>
                <Radio value="否">否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item label="容納人數">
              <Input
                value={publicMaxAppointmentsNumber}
                name="publicMaxAppointmentsNumber"
                placeholder="請輸入人數"
                onChange={(value) => {
                  setPublicMaxAppointmentsNumber(value);
                }}
              />
            </Form.Item>
            {allowedFuncs.includes('點數管理') && (
              <Form.Item label="扣點方式(小時)">
                <Input
                  value={publicDeductPoints}
                  name="publicDeductPoints"
                  placeholder="請輸入點數"
                  onChange={(value) => {
                    setPublicDeductPoints(value);
                  }}
                />
              </Form.Item>
            )}
            <Form.Item label="可出租設備">
              <Select
                mode="tags"
                value={publicRentalEquipment}
                style={{ width: '100%' }}
                placeholder="請輸入設備名稱 按Enter確"
                onChange={(value) => {
                  setPublicRentalEquipment(value);
                }}
              />
            </Form.Item>
            <Form.Item label="公設簡介">
              <Input.TextArea
                value={publicContent}
                name="publicContent"
                placeholder="請輸入內容"
                maxLength={100}
                rows={4}
                hasLimitHint
                aria-label="input max length 100"
                onChange={(value) => {
                  setPublicContent(value);
                }}
              />
            </Form.Item>
          </div>

          <div className={styles.publicContainerRight}>
            <Form.Item label="上傳照片">
              <Button
                onClick={() => {
                  uploadFile.current.click();
                }}
              >
                選擇檔案
              </Button>
              <input
                style={{ display: 'none' }}
                accept="image/png, image/jpeg"
                ref={uploadFile}
                onChange={handleFiles}
                type="file"
                id="file"
                name="files"
                // multiple
              />
            </Form.Item>
            {/* <img style={{ width: "50px", height: "50px" }} src={`${parsed64.length > 0 ? parsed64 : file}`} alt="圖片"></img> */}
            <Image
              className={styles.photo}
              src={`${parsed64.length > 0 ? parsed64 : file}`}
              alt="圖片"
            />
            <Form.Item label="上傳設施規範">
              {' '}
              <Space wrap>
                <Button
                  onClick={() => {
                    uploadRef.current.click();
                  }}
                >
                  {attachment ? '更換附件' : '上傳附件'}
                </Button>
                {uploadData && (
                  <>
                    <Typography.Text type="secondary">
                      {uploadData.name}
                    </Typography.Text>
                    <Button
                      text
                      onClick={() => {
                        setUploadData(null);
                        setUploadPath('');
                      }}
                      style={{ opacity: 0.45 }}
                    >
                      清除
                    </Button>
                  </>
                )}
                {!uploadData && attachment && (
                  <>
                    <Typography.Text type="secondary">
                      {attachment.name}
                    </Typography.Text>
                    <Button
                      text
                      onClick={() => {
                        setAttachment(null);
                      }}
                      style={{ opacity: 0.45 }}
                    >
                      清除
                    </Button>
                  </>
                )}
                {}
              </Space>
              <input
                ref={uploadRef}
                type="file"
                id="upload"
                style={{ display: 'none' }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  setUploadData(file);
                  setUploadPath(e.target.value);
                }}
              />
            </Form.Item>
            <Form.Item label="門禁卡機語音播放">
              <Select
                value={publicBaId}
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                onChange={(value) => setPublicBaId(value)}
              >
                {baDeviceArr.map((item) => (
                  <Option value={item._id}>{item.tableText}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="開放時間">
              <div className={styles.openTime}>
                {dayAllowTime.map((dayItem, index) => (
                  <div className={styles.OpenTimeContent}>
                    <div>
                      星期{week[index]}{' '}
                      <EditOutlined
                        style={{ marginLeft: '10px' }}
                        onClick={() => {
                          setOpenTimeIndex(index);
                          setOpenTimeDialog(true);
                          setOpenTime(dayAllowTime);
                        }}
                      />
                    </div>
                    <div>
                      {dayItem.length === 0 ? (
                        <div>非開放</div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'right',
                          }}
                        >
                          {dayItem.map((timeItem) => {
                            if (timeItem[0] === 0 && timeItem[1] === 24) {
                              return <div>24小時開放</div>;
                            } else {
                              return (
                                <div>{`${timeItem[0]}:00 - ${timeItem[1]}:00`}</div>
                              );
                            }
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <p>備註</p>
              <Input.TextArea
                value={publicOpenTimeRemarks}
                name="publicOpenTimeContent"
                placeholder="請輸入內容"
                maxLength={100}
                rows={4}
                hasLimitHint
                aria-label="input max length 100"
                onChange={(value) => {
                  setPublicOpenTimeRemarks(value);
                }}
              />
            </Form.Item>
          </div>
        </div>
      </Dialog>

      <Card free>
        <Card.Content>
          <h1>時段預約</h1>
          <Table dataSource={currentHourPosts} onSort={onTableHourSort}>
            <Table.Column
              title="建立時間"
              dataIndex="createdTime"
              width={200}
              sortable
              lock="left"
              cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
            />
            <Table.Column
              title="公設名稱"
              dataIndex="publicName"
              width={200}
              sortable
            />
            <Table.Column
              title="使用時間限制"
              dataIndex="publicUsageTime"
              width={200}
              sortable
            />
            <Table.Column
              title="是否多戶預約"
              dataIndex="publicMultipleAppointments"
              width={200}
              sortable
            />
            <Table.Column
              title="容納人數"
              dataIndex="publicMaxAppointmentsNumber"
              width={200}
              sortable
            />
            {allowedFuncs.includes('點數管理') && (
              <Table.Column
                title="扣點方式(小時)"
                dataIndex="publicDeductPoints"
                width={200}
              />
            )}
            <Table.Column
              title="圖片"
              width={100}
              cell={(record, index) => {
                return (
                  <>
                    {currentHourPosts[index].files[0] !== '' ? (
                      <Image
                        className={styles.photo}
                        src={currentHourPosts[index].files[0]}
                        alt="圖片"
                      />
                    ) : null}
                  </>
                );
              }}
            />
            <Table.Column
              title="操作"
              width={300}
              lock="right"
              cell={(value, index, record) => {
                return (
                  <div className={styles.btn}>
                    <Button
                      type="secondary"
                      onClick={() => {
                        setPreviewHour([record]);
                        setPreviewHourDialog(true);
                      }}
                    >
                      查看
                    </Button>
                    <Button
                      type="normal"
                      onClick={() => {
                        setPublicName(record.publicName);
                        setPublicUsageTime(record.publicUsageTime);
                        setPublicMultipleAppointments(
                          record.publicMultipleAppointments
                        );
                        setPublicMaxAppointmentsNumber(
                          record.publicMaxAppointmentsNumber
                        );
                        setPublicDeductPoints(record.publicDeductPoints);
                        setPublicRentalEquipment(record.publicRentalEquipment);
                        setPublicContent(record.publicContent);
                        setPublicOpenTimeRemarks(record.publicOpenTimeRemarks);
                        setFile(record.files);
                        setEditPublicIndex(index);
                        setEditPublicHourDialog(true);
                        setAttachment(record.rule);
                        setDayAllowTime(record.dayAllowTime);
                        setOpenTimeStatus(record.openTimeStatus);
                        setPublicExpireTime(
                          record.publicExpireTime.split('')[0]
                        );
                        setPublicExpireUnit(
                          record.publicExpireTime.split('')[1]
                        );
                        setErrorText('');
                        setPublicBaId(record.baId);
                      }}
                    >
                      編輯
                    </Button>

                    <Button
                      type="primary"
                      warning
                      onClick={() => {
                        Swal.fire({
                          title: `確定刪除公設(${record.publicName})資料?`,
                          text: '刪除後將無法復原!!',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#BEBEBE',
                          confirmButtonText: '確定',
                          cancelButtonText: '取消',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            Swal.fire('刪除!', '此公設已刪除', 'success');
                            removeHour(currentHourPosts[index]._id).then(() => {
                              const prePages =
                                currentPageHour - 1 >= 0
                                  ? currentPageHour - 1
                                  : 0;
                              if (
                                publicInformationHourArr.length - 1 <=
                                prePages * postsPerPage
                              ) {
                                setCurrentPageHour(
                                  currentPageHour - 1 < 1
                                    ? 1
                                    : currentPageHour - 1
                                );
                              }
                              serverDataUpdate();
                            });
                          }
                        });
                      }}
                    >
                      刪除
                    </Button>
                  </div>
                );
              }}
            />
          </Table>
          <Pagination
            className={styles.pagination}
            total={publicInformationHourArr.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentPageHour(pageNumber);
            }}
          />
        </Card.Content>
      </Card>

      {/* 每次預約新增 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addPublicCountDialog}
        onOk={async () => {
          if (!publicName) {
            Message.warning('請填寫公設名稱');
            return;
          } else if (!publicMultipleAppointments) {
            Message.warning('請勾選是否同時段多戶預約');
            return;
          } else if (!publicMaxAppointmentsNumber) {
            Message.warning('請填寫容納人數');
            return;
          }
          if (publicName) {
            const hourRes = await publicInformationHour.find({
              query: { publicName },
            });
            const countRes = await publicInformationCount.find({
              query: { publicName },
            });
            if (hourRes.total > 0 || countRes.total > 0) {
              Message.warning('此公設名稱已存在');
              return;
            }
          }

          const result = await Swal.fire({
            title: `確定新增(${publicName})公設?`,
            text: '請確認資料填寫完整!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          });
          if (result.isConfirmed) {
            Swal.fire('成功!', '此公設已新增', 'success');
            const formData = new FormData();

            let nowRule = {};
            if (uploadData) {
              const body = new FormData();
              body.append('files', uploadData);
              if (uploadData.size / 1024 / 1024 > 20) {
                return Message.error('上傳檔案不能超過20MB');
              }

              const res = await axios(
                '/newUploads?type=publicInformationCount&category=規範',
                {
                  method: 'POST',
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                  data: body,
                }
              );
              const { showPath, _id } = await res.data;
              nowRule = {
                path: showPath,
                name: uploadData.name,
                id: _id,
              };
            }
            formData.append('createdTime', new Date().getTime());
            formData.append('updatedTime', new Date().getTime());
            formData.append('publicName', publicName);
            formData.append(
              'publicExpireTime',
              publicExpireTime + publicExpireUnit
            );
            formData.append('publicDeductPoints', publicDeductPoints);
            formData.append(
              'publicMultipleAppointments',
              publicMultipleAppointments
            );
            formData.append(
              'publicMaxAppointmentsNumber',
              publicMaxAppointmentsNumber
            );
            formData.append(
              'publicRentalEquipment',
              JSON.stringify(publicRentalEquipment)
            );
            formData.append('publicContent', publicContent);
            formData.append('publicOpenTimeRemarks', publicOpenTimeRemarks); // 備註
            formData.append('dayAllowTime', JSON.stringify(dayAllowTime)); // 開放時間
            formData.append('openTimeStatus', JSON.stringify(openTimeStatus)); // 開放時段
            formData.append('baId', JSON.stringify(publicBaId));
            if (uploadData) {
              formData.append('rule', JSON.stringify(nowRule));
            }
            if (uploadFile.current.files.length > 0) {
              formData.append('files', uploadFile.current.files[0]);
            }

            await axios('/uploads?type=publicInformationCount', {
              method: 'POST',
              headers: { authorization: window.localStorage['feathers-jwt'] },
              data: formData,
            });

            serverDataUpdateNew();
            setPublicName('');
            // setPublicUsageTime('');
            setPublicMultipleAppointments('');
            setPublicMaxAppointmentsNumber('');
            setPublicDeductPoints('');
            setPublicRentalEquipment('');
            setPublicContent('');
            setPublicOpenTimeRemarks('');
            setFile('');
            setParsed64('');
            setOpenTime([[], [], [], [], [], [], []]);
            setOpenTimeStatus(['no', 'no', 'no', 'no', 'no', 'no', 'no']);
            setOpenTimeIndex(1);
            setDayAllowTime([[], [], [], [], [], [], []]);
            setPublicExpireTime(1);
            setPublicExpireUnit('天');
            setAddPublicHourDialog(false);
            setAddPublicCountDialog(false);
            setUploadData('');
            setPublicBaId([]);
          }
        }}
        onCancel={() => {
          setPublicName('');
          // setPublicUsageTime('');
          setPublicMultipleAppointments('');
          setPublicMaxAppointmentsNumber('');
          setPublicDeductPoints('');
          setPublicRentalEquipment('');
          setPublicContent('');
          setPublicOpenTimeRemarks('');
          setFile('');
          setParsed64('');
          setOpenTime([[], [], [], [], [], [], []]);
          setOpenTimeStatus(['no', 'no', 'no', 'no', 'no', 'no', 'no']);
          setOpenTimeIndex(1);
          setDayAllowTime([[], [], [], [], [], [], []]);
          setPublicExpireTime(1);
          setPublicExpireUnit('天');
          setAddPublicHourDialog(false);
          setAddPublicCountDialog(false);
          setPublicBaId([]);
        }}
        onClose={() => {
          setPublicName('');
          // setPublicUsageTime('');
          setPublicMultipleAppointments('');
          setPublicMaxAppointmentsNumber('');
          setPublicDeductPoints('');
          setPublicRentalEquipment('');
          setPublicContent('');
          setPublicOpenTimeRemarks('');
          setFile('');
          setParsed64('');
          setOpenTime([[], [], [], [], [], [], []]);
          setOpenTimeStatus(['no', 'no', 'no', 'no', 'no', 'no', 'no']);
          setOpenTimeIndex(1);
          setDayAllowTime([[], [], [], [], [], [], []]);
          setPublicExpireTime(1);
          setPublicExpireUnit('天');
          setAddPublicHourDialog(false);
          setAddPublicCountDialog(false);
          setPublicBaId([]);
        }}
      >
        <h1>公設資料</h1>
        <div className={styles.publicInformationContainer}>
          <div className={styles.publicContainerLeft}>
            <Form.Item label="公設名稱">
              <Input
                name="publicName"
                placeholder="請輸入公設名稱"
                onChange={async (value) => {
                  setPublicName(value);
                  const hourRes = await publicInformationHour.find({
                    query: { publicName: value },
                  });
                  const countRes = await publicInformationCount.find({
                    query: { publicName: value },
                  });
                  if (hourRes.total > 0 || countRes.total > 0) {
                    setErrorText('此公設名稱已存在');
                  } else {
                    setErrorText('');
                  }
                }}
              />
              {errorText && <p style={{ color: '#FF0000' }}>{errorText}</p>}
            </Form.Item>
            <Form.Item label="開放預約期限">
              <Input.Group addonAfter={select}>
                <NumberPicker
                  value={publicExpireTime}
                  min={1}
                  onChange={(value) => {
                    setPublicExpireTime(value);
                  }}
                />
              </Input.Group>
            </Form.Item>

            <Form.Item label="是否同時段多戶預約">
              <Radio.Group
                onChange={(e) => {
                  setPublicMultipleAppointments(e.target.value);
                }}
                // value={publicMultipleAppointments}
              >
                <Radio value="是">是</Radio>
                <Radio value="否">否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item label="容納人數">
              <Input
                name="publicMaxAppointmentsNumber"
                placeholder="請輸入人數"
                onChange={(value) => {
                  setPublicMaxAppointmentsNumber(value);
                }}
              />
            </Form.Item>
            {allowedFuncs.includes('點數管理') && (
              <Form.Item label="扣點方式(每次)">
                <Input
                  name="publicDeductPoints"
                  placeholder="請輸入點數"
                  onChange={(value) => {
                    setPublicDeductPoints(value);
                  }}
                />
              </Form.Item>
            )}
            <Form.Item label="可出租設備">
              <Select
                mode="tags"
                style={{ width: '100%' }}
                placeholder="請輸入設備名稱 按Enter確"
                onChange={(value) => {
                  setPublicRentalEquipment(value);
                }}
              />
            </Form.Item>
            <Form.Item label="公設簡介">
              <Input.TextArea
                name="publicContent"
                placeholder="請輸入內容"
                maxLength={100}
                rows={4}
                hasLimitHint
                aria-label="input max length 100"
                onChange={(value) => {
                  setPublicContent(value);
                }}
              />
            </Form.Item>
          </div>

          <div className={styles.publicContainerRight}>
            <Form.Item label="上傳照片">
              <Button
                onClick={() => {
                  uploadFile.current.click();
                }}
              >
                選擇檔案
              </Button>
              <input
                style={{ display: 'none' }}
                accept="image/png, image/jpeg"
                ref={uploadFile}
                onChange={handleFiles}
                type="file"
                id="file"
                name="files"
                // multiple
              />
            </Form.Item>
            <Image
              className={styles.photo}
              src={`${parsed64.length > 0 ? parsed64 : ezconImg}`}
              alt="圖片"
            />
            <Form.Item label="上傳設施規範">
              {' '}
              <Space wrap>
                <Button
                  onClick={() => {
                    uploadRef.current.click();
                  }}
                >
                  {attachment ? '更換附件' : '上傳附件'}
                </Button>
                {uploadData && (
                  <>
                    <Typography.Text type="secondary">
                      {uploadData.name}
                    </Typography.Text>
                    <Button
                      text
                      onClick={() => {
                        setUploadData(null);
                        setUploadPath('');
                      }}
                      style={{ opacity: 0.45 }}
                    >
                      清除
                    </Button>
                  </>
                )}
              </Space>
              <input
                ref={uploadRef}
                type="file"
                id="upload"
                style={{ display: 'none' }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  setUploadData(file);
                  setUploadPath(e.target.value);
                }}
              />
            </Form.Item>
            <Form.Item label="門禁卡機語音播放">
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                onChange={(value) => setPublicBaId(value)}
              >
                {baDeviceArr.map((item) => (
                  <Option value={item._id}>{item.tableText}</Option>
                ))}
              </Select>
            </Form.Item>
            {/* <img style={{ width: "50px", height: "50px" }} src={`${parsed64.length > 0 ? parsed64 : ezconImg}`} alt="圖片"></img> */}
            <Form.Item label="開放時間">
              <div className={styles.openTime}>
                {dayAllowTime.map((dayItem, index) => (
                  <div className={styles.OpenTimeContent}>
                    <div>
                      星期{week[index]}{' '}
                      <EditOutlined
                        style={{ marginLeft: '10px' }}
                        onClick={() => {
                          setOpenTimeIndex(index);
                          setOpenTimeDialog(true);
                          setOpenTime(dayAllowTime);
                        }}
                      />
                    </div>
                    <div>
                      {dayItem.length === 0 ? (
                        <div>非開放</div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'right',
                          }}
                        >
                          {dayItem.map((timeItem) => {
                            if (timeItem[0] === 0 && timeItem[1] === 24) {
                              return <div>24小時開放</div>;
                            } else {
                              return (
                                <div>{`${timeItem[0]}:00 - ${timeItem[1]}:00`}</div>
                              );
                            }
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <p>備註</p>
              <Input.TextArea
                name="publicOpenTimeContent"
                placeholder="請輸入內容"
                maxLength={100}
                rows={4}
                hasLimitHint
                aria-label="input max length 100"
                onChange={(value) => {
                  setPublicOpenTimeRemarks(value);
                }}
              />
            </Form.Item>
          </div>
        </div>
      </Dialog>
      <br />

      {/* 每次預約編輯 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={editPublicCountDialog}
        onOk={async () => {
          const result = await Swal.fire({
            title: `確定修改公設(${publicName})資料?`,
            text: '請確認修改資料!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          });

          if (result.isConfirmed) {
            Swal.fire('成功!', '此公設修改成功', 'success');

            let nowRule = {};
            if (uploadData) {
              const body = new FormData();
              body.append('files', uploadData);
              if (uploadData.size / 1024 / 1024 > 20) {
                return Message.error('上傳檔案不能超過20MB');
              }

              const res = await axios(
                '/newUploads?type=publicInformationCount&category=規範',
                {
                  method: 'POST',
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                  data: body,
                }
              );
              const { showPath, _id } = await res.data;
              nowRule = {
                path: showPath,
                name: uploadData.name,
                id: _id,
              };
            }

            const data = currentCountPosts[editPublicIndex];
            let patchUrl = `/uploads?type=publicInformationCount&id=${data._id}`;

            const formData = new FormData();
            formData.append('updatedTime', new Date().getTime());
            formData.append('publicName', publicName);
            formData.append(
              'publicExpireTime',
              publicExpireTime + publicExpireUnit
            );
            formData.append('publicDeductPoints', publicDeductPoints);
            formData.append(
              'publicMultipleAppointments',
              publicMultipleAppointments
            );
            formData.append(
              'publicMaxAppointmentsNumber',
              publicMaxAppointmentsNumber
            );
            formData.append(
              'publicRentalEquipment',
              JSON.stringify(publicRentalEquipment)
            );
            formData.append('publicContent', publicContent);
            formData.append('publicOpenTimeRemarks', publicOpenTimeRemarks); // 備註
            formData.append('dayAllowTime', JSON.stringify(dayAllowTime)); // 開放時間
            formData.append('openTimeStatus', JSON.stringify(openTimeStatus)); // 開放時段
            formData.append('baId', JSON.stringify(publicBaId));
            if (uploadData) {
              formData.append('rule', JSON.stringify(nowRule));
            }
            if (uploadFile.current.files.length > 0) {
              formData.append('files', uploadFile.current.files[0]);
            }
            if (!uploadFile.current.files.length) {
              patchUrl = `/uploads?type=publicInformationCount&id=${data._id}&img=keep`;
            }

            await axios(patchUrl, {
              method: 'PATCH',
              headers: { authorization: window.localStorage['feathers-jwt'] },
              data: formData,
            });

            serverDataUpdateNew();
            setPublicName('');
            setPublicMultipleAppointments('');
            setPublicMaxAppointmentsNumber('');
            setPublicDeductPoints('');
            setPublicRentalEquipment('');
            setPublicContent('');
            setPublicOpenTimeRemarks('');
            setFile('');
            setParsed64('');
            setOpenTime([[], [], [], [], [], [], []]);
            setOpenTimeStatus(['no', 'no', 'no', 'no', 'no', 'no', 'no']);
            setOpenTimeIndex(1);
            setDayAllowTime([[], [], [], [], [], [], []]);
            setPublicExpireTime(1);
            setPublicExpireUnit('天');
            setAddPublicHourDialog(false);
            setEditPublicCountDialog(false);
            setPublicBaId([]);
          }
        }}
        onCancel={() => {
          setPublicName('');
          setPublicMultipleAppointments('');
          setPublicMaxAppointmentsNumber('');
          setPublicDeductPoints('');
          setPublicRentalEquipment('');
          setPublicContent('');

          setPublicOpenTimeRemarks('');
          setFile('');
          setOpenTime([[], [], [], [], [], [], []]);
          setOpenTimeStatus(['no', 'no', 'no', 'no', 'no', 'no', 'no']);
          setOpenTimeIndex(1);
          setDayAllowTime([[], [], [], [], [], [], []]);
          setPublicExpireTime(1);
          setPublicExpireUnit('天');
          setAddPublicHourDialog(false);
          setEditPublicCountDialog(false);
          setPublicBaId([]);
        }}
        onClose={() => {
          setPublicName('');
          setPublicMultipleAppointments('');
          setPublicMaxAppointmentsNumber('');
          setPublicDeductPoints('');
          setPublicRentalEquipment('');
          setPublicContent('');
          setPublicOpenTimeRemarks('');
          setFile('');
          setOpenTime([[], [], [], [], [], [], []]);
          setOpenTimeStatus(['no', 'no', 'no', 'no', 'no', 'no', 'no']);
          setOpenTimeIndex(1);
          setDayAllowTime([[], [], [], [], [], [], []]);
          setPublicExpireTime(1);
          setPublicExpireUnit('天');
          setAddPublicHourDialog(false);
          setEditPublicCountDialog(false);
          setPublicBaId([]);
        }}
      >
        <h3>公設資料編輯</h3>
        <div className={styles.publicInformationContainer}>
          <div className={styles.publicContainerLeft}>
            <Form.Item label="公設名稱">
              <Input
                value={publicName}
                name="publicName"
                placeholder="請輸入公設名稱"
                onChange={(value) => {
                  setPublicName(value);
                }}
              />
            </Form.Item>
            <Form.Item label="開放預約期限">
              <Input.Group addonAfter={select}>
                <NumberPicker
                  value={publicExpireTime}
                  min={1}
                  onChange={(value) => {
                    setPublicExpireTime(value);
                  }}
                />
              </Input.Group>
            </Form.Item>
            <Form.Item label="是否同時段多戶預約">
              <Radio.Group
                value={publicMultipleAppointments}
                onChange={(e) => {
                  setPublicMultipleAppointments(e.target.value);
                }}
              >
                <Radio value="是">是</Radio>
                <Radio value="否">否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item label="容納人數">
              <Input
                value={publicMaxAppointmentsNumber}
                name="publicMaxAppointmentsNumber"
                placeholder="請輸入人數"
                onChange={(value) => {
                  setPublicMaxAppointmentsNumber(value);
                }}
              />
            </Form.Item>
            {allowedFuncs.includes('點數管理') && (
              <Form.Item label="扣點方式(每次)">
                <Input
                  value={publicDeductPoints}
                  name="publicDeductPoints"
                  placeholder="請輸入點數"
                  onChange={(value) => {
                    setPublicDeductPoints(value);
                  }}
                />
              </Form.Item>
            )}
            <Form.Item label="可出租設備">
              <Select
                mode="tags"
                value={publicRentalEquipment}
                style={{ width: '100%' }}
                placeholder="請輸入設備名稱 按Enter確"
                onChange={(value) => {
                  setPublicRentalEquipment(value);
                }}
              />
            </Form.Item>
            <Form.Item label="公設簡介">
              <Input.TextArea
                value={publicContent}
                name="publicContent"
                placeholder="請輸入內容"
                maxLength={100}
                rows={4}
                hasLimitHint
                aria-label="input max length 100"
                onChange={(value) => {
                  setPublicContent(value);
                }}
              />
            </Form.Item>
          </div>

          <div className={styles.publicContainerRight}>
            <Form.Item label="上傳照片">
              <Button
                onClick={() => {
                  uploadFile.current.click();
                }}
              >
                選擇檔案
              </Button>
              <input
                style={{ display: 'none' }}
                accept="image/png, image/jpeg"
                ref={uploadFile}
                onChange={handleFiles}
                type="file"
                id="file"
                name="files"
                // multiple
              />
            </Form.Item>
            <Image
              className={styles.photo}
              src={`${parsed64.length > 0 ? parsed64 : file}`}
              alt="圖片"
            />
            {/* <img style={{ width: "50px", height: "50px" }} src={`${parsed64.length > 0 ? parsed64 : file}`} alt="圖片"></img> */}
            <Form.Item label="上傳設施規範">
              {' '}
              <Space wrap>
                <Button
                  onClick={() => {
                    uploadRef.current.click();
                  }}
                >
                  {attachment ? '更換附件' : '上傳附件'}
                </Button>
                {uploadData && (
                  <>
                    <Typography.Text type="secondary">
                      {uploadData.name}
                    </Typography.Text>
                    <Button
                      text
                      onClick={() => {
                        setUploadData(null);
                        setUploadPath('');
                      }}
                      style={{ opacity: 0.45 }}
                    >
                      清除
                    </Button>
                  </>
                )}
                {!uploadData && attachment && (
                  <>
                    <Typography.Text type="secondary">
                      {attachment.name}
                    </Typography.Text>
                    <Button
                      text
                      onClick={() => {
                        setAttachment(null);
                      }}
                      style={{ opacity: 0.45 }}
                    >
                      清除
                    </Button>
                  </>
                )}
                {}
              </Space>
              <input
                ref={uploadRef}
                type="file"
                id="upload"
                style={{ display: 'none' }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  setUploadData(file);
                  setUploadPath(e.target.value);
                }}
              />
            </Form.Item>
            <Form.Item label="BA語音播放">
              <Select
                value={publicBaId}
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                onChange={(value) => setPublicBaId(value)}
              >
                {baDeviceArr.map((item) => (
                  <Option value={item._id}>{item.tableText}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="開放時間">
              <div className={styles.openTime}>
                {dayAllowTime.map((dayItem, index) => (
                  <div className={styles.OpenTimeContent}>
                    <div>
                      星期{week[index]}{' '}
                      <EditOutlined
                        style={{ marginLeft: '10px' }}
                        onClick={() => {
                          setOpenTimeIndex(index);
                          setOpenTimeDialog(true);
                          setOpenTime(dayAllowTime);
                        }}
                      />
                    </div>
                    <div>
                      {dayItem.length === 0 ? (
                        <div>非開放</div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'right',
                          }}
                        >
                          {dayItem.map((timeItem) => {
                            if (timeItem[0] === 0 && timeItem[1] === 24) {
                              return <div>24小時開放</div>;
                            } else {
                              return (
                                <div>{`${timeItem[0]}:00 - ${timeItem[1]}:00`}</div>
                              );
                            }
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <p>備註</p>
              <Input.TextArea
                value={publicOpenTimeRemarks}
                name="publicOpenTimeContent"
                placeholder="請輸入內容"
                maxLength={100}
                rows={4}
                hasLimitHint
                aria-label="input max length 100"
                onChange={(value) => {
                  setPublicOpenTimeRemarks(value);
                }}
              />
            </Form.Item>
          </div>
        </div>
      </Dialog>

      <Card free>
        <Card.Content>
          <h1>計次預約</h1>
          <Table dataSource={currentCountPosts} onSort={onTableCountSort}>
            <Table.Column
              title="建立時間"
              dataIndex="createdTime"
              width={200}
              sortable
              lock="left"
              cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
            />
            <Table.Column
              title="公設名稱"
              dataIndex="publicName"
              width={200}
              sortable
            />
            <Table.Column
              title="是否多戶預約"
              dataIndex="publicMultipleAppointments"
              width={200}
              sortable
            />
            <Table.Column
              title="容納人數"
              dataIndex="publicMaxAppointmentsNumber"
              width={200}
              sortable
            />
            {allowedFuncs.includes('點數管理') && (
              <Table.Column
                title="扣點方式(每次)"
                dataIndex="publicDeductPoints"
                width={200}
              />
            )}
            <Table.Column
              title="圖片"
              width={100}
              cell={(_value, index) => {
                return (
                  <>
                    {currentCountPosts[index].files[0] !== '' ? (
                      <Image
                        className={styles.photo}
                        src={currentCountPosts[index].files[0]}
                        alt="圖片"
                      />
                    ) : null}

                    {/* <img className={styles.imageUrl} alt="No Data" src={currentCountPosts[index].files} /> */}
                  </>
                );
              }}
            />
            <Table.Column
              title="操作"
              width={300}
              lock="right"
              cell={(_value, index, record) => {
                return (
                  <div className={styles.btn}>
                    <Button
                      type="secondary"
                      onClick={() => {
                        setPreviewCount([record]);
                        setPreviewCountDialog(true);
                      }}
                    >
                      查看
                    </Button>
                    <Button
                      type="normal"
                      onClick={() => {
                        setPublicName(record.publicName);
                        setPublicMultipleAppointments(
                          record.publicMultipleAppointments
                        );
                        setPublicMaxAppointmentsNumber(
                          record.publicMaxAppointmentsNumber
                        );
                        setPublicDeductPoints(record.publicDeductPoints);
                        setPublicRentalEquipment(record.publicRentalEquipment);
                        setPublicContent(record.publicContent);
                        setPublicOpenTimeRemarks(record.publicOpenTimeRemarks);
                        setFile(record.files);
                        setEditPublicIndex(index);
                        setEditPublicCountDialog(true);
                        setAttachment(record.rule);
                        setErrorText('');
                        setDayAllowTime(record.dayAllowTime);
                        setOpenTimeStatus(record.openTimeStatus);
                        setPublicExpireTime(
                          record.publicExpireTime.split('')[0]
                        );
                        setPublicExpireUnit(
                          record.publicExpireTime.split('')[1]
                        );
                        setPublicBaId(record.baId);
                      }}
                    >
                      編輯
                    </Button>

                    <Button
                      type="primary"
                      warning
                      onClick={() => {
                        Swal.fire({
                          title: `確定刪除公設(${record.publicName})資料?`,
                          text: '刪除後將無法復原!!',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#BEBEBE',
                          confirmButtonText: '確定',
                          cancelButtonText: '取消',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            Swal.fire('刪除!', '此公設已刪除', 'success');
                            removeCount(currentCountPosts[index]._id).then(
                              () => {
                                const prePages =
                                  currentPageCount - 1 >= 0
                                    ? currentPageCount - 1
                                    : 0;
                                if (
                                  publicInformationCountArr.length - 1 <=
                                  prePages * postsPerPage
                                ) {
                                  setCurrentPageCount(
                                    currentPageCount - 1 < 1
                                      ? 1
                                      : currentPageCount - 1
                                  );
                                }
                                serverDataUpdateNew();
                              }
                            );
                          }
                        });
                      }}
                    >
                      刪除
                    </Button>
                  </div>
                );
              }}
            />
          </Table>
          <Pagination
            className={styles.pagination}
            total={publicInformationCountArr.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentPageCount(pageNumber);
            }}
          />
        </Card.Content>
      </Card>
    </>
  );
};

export default PublicInformation;
